import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  ActionBar,
  ActionButton,
  DetailFieldTitle,
  DetailFieldValue,
  Header,
  ReturnCardContentWrapper,
  ReturnItemsWrapper,
} from './styles';
import { ItemCard } from '../ItemCard';
import { getInitiatedReturnsHeader } from './utils';
import { OrderGroupHeader } from '../ItemOrderGroup/OrderGroupHeader';
import { itemProps, returnLabelProps } from '../Items/proptypes';
import { mutations } from '../Items/hooks/utils';

const ReturnCardContent = ({ returnItems, itemQtyKey }) => (
  <ReturnCardContentWrapper>
    {mutations({
      items: returnItems,
      mutationConfigs: [{ type: 'quantity', key: 'qty' }],
    }).map((item, itemIndex) => (
      <ItemCard {...{ itemIndex, item, key: item.item_id, readOnly: true, itemQtyKey }} />
    ))}
  </ReturnCardContentWrapper>
);

const mapStateToProps = ({
  language: {
    'returns.step_1.reprint_label_btn': reprintLabel,
    'returns.step_1.track_return_btn': trackLabel,
  } = {},
}) => ({
  reprintLabel,
  trackLabel,
});

const DetailField = ({ title, value }) => (
  <DetailFieldValue>
    <DetailFieldTitle>{title}</DetailFieldTitle>
    <DetailFieldValue>{value}</DetailFieldValue>
  </DetailFieldValue>
);

export const ReturnCardComponent = ({
  label,
  label: { return_items: returnItems },
  handlers: { printLabel },
  flags: { showButtonTrack, showButtonReprintLabel, isNotShipped },
  reprintLabel,
  trackLabel,
  itemQtyKey,
}) => {
  const handlePrintLabel = () => {
    printLabel(label, {
      preventDefault: () => {},
    });
  };

  const generateActions = () => {
    const actions = [];

    // Not Shipped
    if (isNotShipped(label)) {
      if (showButtonReprintLabel(label)) {
        actions.push(
          <ActionButton key="reprintLabel" onClick={handlePrintLabel}>
            {reprintLabel}
          </ActionButton>,
        );
      }
      /* Uncomment when cancel has been added to redux actions
        if (showButtonCancel(label)) {
          actions.push(<ActionButton onClick={handleCancelLabel}>Cancel Return</ActionButton>);
        }
      */
    }

    // Shipped
    if (!isNotShipped(label)) {
      if (showButtonTrack(label)) {
        actions.push(
          <ActionButton key="trackLabel">
            <a href={label.tracking_url} target="_blank" rel="noopener noreferrer">
              {trackLabel}
            </a>
          </ActionButton>,
        );
      }
    }

    return actions;
  };

  return (
    <div>
      <h4 className="initiated-returns-header step1Ctrl-module_label_header_2QW">
        {getInitiatedReturnsHeader({ label })}
      </h4>
      <Header className="my-returns-card-header">
        <ActionBar>{generateActions()}</ActionBar>
      </Header>
      <ReturnItemsWrapper>
        <OrderGroupHeader title={label.order_number} />
        <ReturnCardContent {...{ returnItems, itemQtyKey }} />
      </ReturnItemsWrapper>
    </div>
  );
};

export const ReturnCard = connect(mapStateToProps)(ReturnCardComponent);

ReturnCardComponent.propTypes = {
  label: PropTypes.shape(returnLabelProps).isRequired,
  handlers: PropTypes.shape({
    printLabel: () => {},
  }).isRequired,
  flags: PropTypes.shape({
    showButtonTrack: () => {},
    showButtonReprintLabel: () => {},
    isNotShipped: () => {},
  }).isRequired,
  reprintLabel: PropTypes.string.isRequired,
  trackLabel: PropTypes.string.isRequired,
};

ReturnCardContent.propTypes = {
  returnItems: PropTypes.arrayOf(PropTypes.shape(itemProps)),
  itemQtyKey: PropTypes.string,
};

ReturnCardContent.defaultProps = {
  returnItems: [],
  itemQtyKey: undefined,
};

DetailField.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
